<template>
  <div id="step-1" class="multi-step-form active-step">
    <div class="d-flex align-content-center">
      <p>
        <a href="https://aliancaadm.com.br">
          <img src="@/assets/arrow-left.svg" alt="OK"
        /></a>
      </p>
    </div>
    <div
      class="d-flex align-content-center align-flex-title"
      style="margin-top: -55px"
    >
      <p>Vamos iniciar a simulação do seu plano de saúde?</p>
    </div>
    <div class="align-flex-title">
      <h3>Digite o seu CEP</h3>
    </div>
    <div class="input-field-simulador">
      <b-form-input
        v-model="cep"
        placeholder="00000-000"
        v-mask="'#####-###'"
        @input="verifyCEPCSS()"
        data-validate="CEP"
        maxlength="9"
        :class="{ 'statusok-fontbold': cep.length > 8 }"
      ></b-form-input>
      <img
        v-if="cep.length > 8"
        class="statusok-check"
        src="@/assets/statusok.svg"
        alt="OK"
      />
      <small>
        Vamos utilizar para encontrarmos o seu estado e cidade, e colocar na sua
        proposta caso faça a compra.
      </small>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div v-if="errors.length">
      <b v-for="erro in errors" :key="erro">{{ erro }}</b>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div class="row consentimento-div">
      <div @click="setEtapa()">
        <b-button
          class="btn-alianca btn-next btn-next btn-next-continuar-simule"
          :class="{ 'btn-clicked': validaCEP === true }"
        >
          CONTINUAR
        </b-button>
        <b-button
          class="btn-alianca btn-next btn-icon-next"
          style="margin-left: -48px !important"
          :class="{ 'btn-clicked-icon': validaCEP === true }"
          ><font-awesome-icon icon="angle-right" class="icon-arrow-right"
        /></b-button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import buscarEnderecoAPI from "@/services/buscarEnderecoAPI";
import buscarEstadoIDAPI from "@/services/buscarEstadoID.js";
import buscarConveniosAPI from "@/services/buscarConvenios";
import buscarEntidadeOrgaoUF from "@/services/buscarEntidadeOrgaoUf";

export default {
  name: "StepUm",
  data() {
    return {
      cep: "",
      errors: [],
      validaCEP: false,
      homeUrl: null,
      listaOrgEnt: []
    };
  },
  computed: {
    estadoEndUf(){
      return store.getters.getAliancaEndUF;
    },
    resBuscaOrgEnt(){
      return buscarEntidadeOrgaoUF(this.estadoEndUf)
    },
    estadoid: {
      get() {
        return store.getters.getAliancaEstadoID;
      },
      set(newVal) {
        store.commit("mutAliancaEstadoID", newVal);
      },
    },
    options_orgaos: {
      get() {
        return store.getters.getSimuleAquiOrgaos;
      },
      set(newVal) {
        store.commit("mutSimuleAquiOrgaos", newVal);
      },
    },
  },
  mounted() {
    this.verificaEnv();
    document.getElementById("step-progress").value = 3;
    document
      .getElementById("step-progress-point1")
      .classList.add("rounded-point-progress-ok");

    store.commit("mutResetState");
  },
  created() {
    this.homeUrl = process.env.VUE_APP_ALIANCA_HOME
  },
  methods: {

    verificaEnv(){
      let cepAlianca = sessionStorage.getItem('AliancaCEP');
      if (!cepAlianca && process.env.NODE_ENV != "development") {
        window.location.href = this.homeUrl;
      }
    },
    verifyCEPCSS() {
      if (this.cep.length == 9) this.validaCEP = true;
      else this.validaCEP = false;
    },
    async validaStep() {
      this.errors = [];

      if (!this.cep || this.cep.length < 9) {
        this.errors.push("Preencha seu cep");
        return false;
      }

      const cepComInfo = await this.getCEPInfo(this.cep);

      if (!cepComInfo) {
        return false;
      }

      return true;
    },
    async getCEPInfo(cep) {
      if (cep.length == 9)
        return await this.buscarEndereco(cep.replace("-", ""));
    },
    async setEtapa() {
      store.commit("mutSimuleAquiLoader", true);

      if (await this.validaStep()) {
        store.commit("mutAliancaCEP", this.cep);
        store.commit("mutAliancaProxEtapa", "step-3-alt");
        store.commit("mutAliancaFuncPub", "Sim");

        await this.getOrgaos();

        store.commit("mutAliancaEstadoID", this.estadoid);

        this.etapa = "step-3-alt";

      }
    },
    async getEstadoSigla(sigla) {
      let estados_json =
        '{"AC":"Acre","AL":"Alagoas","AP":"Amapá","AM":"Amazonas","BA":"Bahia","CE":"Ceará","DF":"Distrito Federal","ES":"Espírito Santo","GO":"Goiás","MA":"Maranhão","MT":"Mato Grosso","MS":"Mato Grosso do Sul","MG":"Minas Gerais","PR":"Paraná","PB":"Paraíba","PA":"Pará","PE":"Pernambuco","PI":"Piauí","RN":"Rio Grande do Norte","RS":"Rio Grande do Sul","RJ":"Rio de Janeiro","RO":"Rondônia","RR":"Roraima","SC":"Santa Catarina","SE":"Sergipe","SP":"São Paulo","TO":"Tocantins"}';
      let estados = JSON.parse(estados_json);

      this.estadoapi = estados[sigla];
      let slugestado = this.slugify(estados[sigla]);
      this.estadoid = await buscarEstadoIDAPI(slugestado);
    },
    slugify(str) {
      str = str.replace(/^\s+|\s+$/g, "");
      str = str.toLowerCase();

      let from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      let to = "aaaaaaeeeeiiiioooouuuunc------";

      for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");

      return str;
    },
    async buscarEndereco(cep) {
      if (cep == "01313020") {
        this.getEstadoSigla("SP");
        store.commit("mutAliancaCEP", cep);
        store.commit("mutAliancaCodEnd", null);
        store.commit("mutAliancaEndBairro", "BELA VISTA");
        store.commit("mutAliancaEndCidade", "SÃO PAULO");
        store.commit("mutAliancaEndComp", "");
        store.commit("mutAliancaEndRua", "RUA DOUTOR PLÍNIO BARRETO");
        store.commit("mutAliancaEndGia", "");
        store.commit("mutAliancaEndIbge", "");
        store.commit("mutAliancaEndTipo", "");
        store.commit("mutAliancaEndUF", "SP");

        return false;
      }

      var endereco = await buscarEnderecoAPI({
        uf: "",
        cep: cep,
        bairro: "",
        cidade: "",
        endereco_benef: "",
      });


      if (!endereco[0]) {
        this.$bvToast.toast("CEP não encontrado", {
          variant: "danger",
          solid: true,
        });

        return false;
      }

      await this.getEstadoSigla(endereco[0].UF);
      store.commit("mutAliancaCEP", endereco[0].CEP);
      store.commit("mutAliancaCodEnd", endereco[0].CODMUN);
      store.commit("mutAliancaEndBairro", endereco[0].BAIRRO);
      store.commit("mutAliancaEndCidade", endereco[0].CIDADE);
      store.commit("mutAliancaEndComp", "");
      store.commit("mutAliancaEndRua", endereco[0].ENDERECO_BENEF);
      store.commit("mutAliancaEndGia", "");
      store.commit("mutAliancaEndIbge", "");
      store.commit("mutAliancaEndTipo", "");
      store.commit("mutAliancaEndUF", endereco[0].UF);
      
      this.getBuscaOrgEnd();
      return true;
    },

    async getBuscaOrgEnd(){
      console.log('estadoEndUf', this.estadoEndUf)
      this.listaOrgEnt = await this.resBuscaOrgEnt;
      let listarEntOrg = this.listaOrgEnt.sort((a, b) => {
        let result = 0;
        if (a.descricao > b.descricao) {
          result = 1;
        } else {
          result = -1;
        }
        return result;
      });
      store.commit("mutAliancaOrgEnt", listarEntOrg);
      console.log('listaOrgEnt', listarEntOrg)
      store.commit("mutSimuleAquiLoader", false);
    },
    async getOrgaos() {
      store.commit("mutSimuleAquiOrgaos", []);

      let options_orgaos = await buscarConveniosAPI(this.estadoid);

      options_orgaos = options_orgaos.map((el) => {
        if (el.categorias.some((elTwo) => elTwo === "entidade")) {
          console.log(el.OrgaoNome.replace("&#8211;", "-"));
        }

        return {
          id: el.slug,
          name: el.OrgaoNome.replace("&#8211;", "-"),
          entidade: el.categorias.some((elTwo) => elTwo === "entidade"),
          cod: el.OrgaoID,
        };
      });

      options_orgaos = options_orgaos.sort((a, b) => {
        let result = 0;

        if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) {
          result = 1;
        } else {
          result = -1;
        }

        return result;
      });

      store.commit("mutSimuleAquiOrgaos", options_orgaos);
    },
  },
};
</script>